import type from '../types';

export const updateActivePage = id => {
  return {
    type: type.UPDATE_ACTIVE_PAGE,
    id
  };
}